import { ConnectionService } from '@app/shared/services/connection.service';
import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  AttributeValue,
  OdataResponse,
} from '@app/shared/interfaces/odata-response';
import * as g from 'src/global-variables';
import { AppConfigService } from '@app/shared/services/app-config.service';
import {
  Attribute,
  AttributeOption,
  AttributeSet,
  AttributeValidator,
  AttributeValidatorModel,
  AttributesGroup,
  GetAttributeValidators,
  Scope,
} from '@app/shared/interfaces/Attribute';
import { ObjectTypeValidValues } from '@product/shared/models/Enums.enum';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { AttributeDTO } from '@product/shared/models/AttributeDTO';
import { tap } from 'rxjs';
import { Translation } from '@app/shared/interfaces/Translation';
import { CommonService } from '@product/shared/services/common.service';
import { PageHeaderComponentModel } from '@app/shared/interfaces/page-header-component-model';
import {
 
  UseInLayeredNavigationValidValues,
 
} from 'src/global-variables';
@Component({
  selector: 'app-attribute',
  templateUrl: './attribute.component.html',
  
  styleUrls: ['./attribute.component.less'],
})
export class AttributeComponent extends BaseComponent implements OnInit {

  @Input() formGroup: FormGroup;
  @Input() mode: string;
  @Input() componentModel: PageHeaderComponentModel;
  @Output() submitChanges: EventEmitter<any> = new EventEmitter();
  private _languageId: number = 0;
  validators: AttributeValidatorModel[] = [];
  public get languageId(): number {
    return this._languageId;
  }
  @Input()
  set languageId(value: number) {
    this._languageId = value;
    if (
      value != null &&
      value > 0 &&
      value != CommonService.DefaultLanguageId
    ) {
     // this.formGroup.disable();
      this.handleLanguageChange();
      this.formGroup.get('Label')?.enable();
    } else {
      if (this.record != null) {
        this.formGroup.get('Label')?.setValue(this.record?.Label);
      }
      this.formGroup.enable();
    }
  }
  listOfOptions: AttributeOption[] = [];
  objectTypes = ObjectTypeValidValues;
  dropDownMeta: { [key: string]: any[] } = {};
  record: any;

  //filter var
  searchQueryControl = new FormControl('');
  filteredData: AttributeSet[] = []; 
  formSearch: FormGroup;
  // pagination var
  currentPage = 1;
  pageSize =5;
  totalItems = 0;


  paginatedData: AttributeSet[] = [];
  attributeSets: AttributeSet[] = [];
  selectedGroups: any = {};
  childAttributesToAdd: Attribute[] = [];
  existedChildAttributes: any[] = [];
  hasUomAttribute: boolean = false;
  uoms: AttributeOption[] = [];

  constructor(injector: Injector) {
    super(injector);
  }
  private originalLabel: string | null = null;
 
  ngOnInit(): void {
    //new 
  this.originalLabel = this.formGroup.get('Label')?.value;

  this. setupDefaultLanguageSubscription();


   this.initFormSearch();
    this.getAttributeGroups();
  this.searchChange();
   
  
    const entityType = this.formGroup.get('RelatedObjectType')?.value;
    if (entityType == null) {
      this.formGroup
        .get('RelatedObjectType')
        ?.valueChanges.subscribe((value) => {
          if (value === 12) {
            this.getAttributeGroups();
          }
        });
    } else if (entityType === 12) {
      this.getAttributeGroups();
    }
    this.validators = [
      ...GetAttributeValidators(this.formGroup.get('Type')?.value),
    ];
    this.subscriptions.push(
      this.formGroup.get('Type')!.valueChanges.subscribe((type) => {
        this.validators = [...GetAttributeValidators(type)];
      })
    );
    this.initializePagination();

  
  }
  initFormSearch(): void {
    this.formSearch = new FormGroup({
      searchQuery: new FormControl(''),
    });
  }
  override submit() {
    this.submitChanges.emit();
  }
  attributeOptionsChanged(options: AttributeOption[]) {
    this.listOfOptions = [...options];
  }
  getAttributeGroups() {
    const entityType = this.formGroup.controls['RelatedObjectType'].value;
    this.dropDownMeta['AttributeGroups'] = [];
    this.connectionService.allEntityData(
      `${AppConfigService.settings.baseUrl}data-api/AttributeGroup?filter=RelatedObjectType eq ${entityType}&expand=AttributeSet`,
      (d: OdataResponse) => {
        let attributeGroups = d.value as AttributesGroup[];
        const uniqueAttributeSets: AttributeSet[] = [];
        attributeGroups.forEach((group) => {
          if (
            uniqueAttributeSets.find((x) => x.Id == group.AttributeSet?.Id) ==
              null &&
            group.AttributeSet != null
          ) {
            uniqueAttributeSets.push(group.AttributeSet!);
            this.selectedGroups[group.AttributeSet!.Id.toString()] = undefined;
          }
        });
        this.attributeSets = uniqueAttributeSets;
        this.filteredData = [...this.attributeSets];
        //this.attributeSets = uniqueAttributeSets;
        this.totalItems = this.attributeSets.length;
        this.paginatedData = this.getPaginatedData();
        
        this.attributeSets.forEach((set) => {
          set.AttributeGroups = attributeGroups.filter(
            (x) => x.AttributeSet?.Id == set.Id
          );
        });
        const selectedGroups: AttributesGroup[] = this.record?.Groups ?? [];
        if (selectedGroups != null && selectedGroups.length > 0) {
          selectedGroups.forEach((x) => {
            this.selectedGroups[x.AttributeSetId!] = x.Id;
          });
        }
        this.dropDownMeta['AttributeGroups'] = [
          ...attributeGroups.map((group) => {
            return {
              Code: group.Id,
              Name: `${group.AttributeSet?.Name} - ${group.Name}`,
            };
          }),
        ];
        this.initializePagination();
      }
    );
  }
 
  
  
  recordLoaded(record: any) {
    try { 
      this.record = record;

      if (this.record.UomAttributeId != null) {

        this.hasUomAttribute = true;
        this.uoms = this.record.UomAttribute?.AttributeOptions;

      //Edit request
        this.connectionService.allEntityData(
          `${AppConfigService.settings.baseUrl}data-api/Attribute/${record.Id}?expand=UomAttribute(expand=AttributeOptions(expand=Translations))`,
          (response: any) => {
            
            this.uoms = (response.UomAttribute?.AttributeOptions || []).map((option: any) => ({
              ...option,
              Translations: option.Translations || [],
            }));
          }
        );
      }
  
      this.getChildAttributes();

      this.listOfOptions = [];
    
      this.connectionService.allEntityData(
        `${AppConfigService.settings.baseUrl}data-api/Attribute/${record.Id}?expand=AttributeOptions(expand=Translations),Groups,UomAttribute(expand=AttributeOptions(expand=Translations))`,

        (d: any) => {
          let options = d.AttributeOptions as any[];
          options.forEach((option) => {
            this.listOfOptions = [...this.listOfOptions, option];
          });
          const attributeGroups = d.Groups;
          const attributeGroupsIds = attributeGroups.map((x: any) => x.Id);
          this.formGroup.get('Groups')?.setValue(attributeGroupsIds);
          const attributeValues =
            record.AttributeValueObjectNavigations as AttributeValue[];
          const attributeValuesControls = (
            this.formGroup.get('AttributeValueObjectNavigations') as FormGroup
          ).controls;
          attributeValues.forEach((val) => {
            const controlKey = Object.keys(attributeValuesControls).find((x) =>
              x.includes(val.AttributeId.toString())
            );
            if (controlKey != null) {
              attributeValuesControls[controlKey].setValue(val.Value);
            }
          });
        }
      );
      if (this.record.AttributeValidators != null) {
        const assignedValidators = this.formGroup.get('AttributeValidators')
          ?.value as AttributeValidator[];
        if (this.record.AttributeValidators.length > 0) {
          this.record.AttributeValidators.forEach((val: AttributeValidator) => {
            const control = assignedValidators.find(
              (x) => x.ValidatorType == val.ValidatorType
            );
            if (control == null) {
              (
                this.formGroup.get('AttributeValidators') as FormArray
              )?.controls.push(
                this.fb.group({
                  Id: new FormControl(val.Id),
                  AttributeId: new FormControl(this.record.Id ?? 0),
                  ValidatorType: new FormControl(val.ValidatorType),
                  ValidatorContent: new FormControl(val.ValidatorContent),
                })
              );
            } else {
              const formControls = (
                this.formGroup.get('AttributeValidators') as FormArray
          
              ).controls as FormGroup[];
              const controlToPath = formControls.find(
                (x) => x.value.ValidatorType == val.ValidatorType
              );
              if (controlToPath != null) {
                controlToPath.setValue(val);
              }
            }
          });
        }
      }
    } catch {}
  }

  cleanRecord(record: any) : any{
    return record;
  }

  beforeSubmit() {
    this.listOfOptions.map((x) => (x.Value = x.Name));
    this.formGroup.controls['AttributeOptions'].setValue(this.listOfOptions);
    const attribute = g.HardCopy(this.formGroup.value);
    const attributeGroupsValue = this.formGroup.get('Groups')
      ?.value as number[];
    if (attributeGroupsValue != null) {
      const attributeGroups: AttributesGroup[] = attributeGroupsValue.map(
        (groupId) => {
          const group: any = {
            Id: groupId,
          };
          return group;
        }
      );
      attribute.Groups = [];
      attribute.Groups = attributeGroups;
    } else {
      attribute.Groups = [];
    }
    const attributeValues = this.formGroup.get(
      'AttributeValueObjectNavigations'
    )?.value;
    const handledAttributeValues: AttributeValue[] = [];
    if (attributeValues != null && Object.keys(attributeValues).length !== 0) {
      Object.keys(attributeValues).forEach((key) => {
        handledAttributeValues.push({
          LanguageId: 0,
          AttributeId: +key.split('.')[1],
          Value: attributeValues[key].toString(),
        });
      });
    }
    attribute.AttributeValueObjectNavigations = handledAttributeValues;
    if (
      attribute.AttributeValueObjectNavigations == null ||
      !Array.isArray(attribute.AttributeValueObjectNavigations)
    ) {
      attribute.AttributeValueObjectNavigations = [];
    }

    //#region UOM
    if (this.uoms?.length > 0) {
      const uomAttribute: Attribute = {
        Id: this.record != undefined ? this.record.UomAttributeId : 0,
        Label: this.record?.UomAttribute?.Label ?? '',
        Name: this.record?.UomAttribute?.Name ?? '',
        Type: g.AttributeTypes.Select,
        AddToCol: false,
        IsUnique: false,
        IsRequired: false,
        Scope: Scope.Global,
        AttributeOptions: this.uoms,
      };
      attribute.UomAttribute = uomAttribute;
     
    }
    //#endregion

    const attributeValidators: AttributeValidator[] = [];
    const validatorsArray = this.formGroup.get(
      'AttributeValidators'
    ) as FormArray;
    const validatorsControls = validatorsArray.controls;
    validatorsControls.forEach((control) => {
      attributeValidators.push(control.value);
    });
    attributeValidators.map((x) => {
      if ((x.ValidatorContent as any) instanceof Date) {
        x.ValidatorContent = JSON.stringify(x.ValidatorContent).replace(
          /"/g,
          ''
        );
      } else {
        x.ValidatorContent = x.ValidatorContent.toString();
      }
      x.AttributeId = this.record.Id;
    });
    attribute.AttributeValidators = attributeValidators;

    if (attribute.DefaultValue != null) {
      attribute.DefaultValue = attribute.DefaultValue.toString();
    }
    return attribute;
  }
  selectedGroupsChange(value: any, attributeSetId: number) {
    this.selectedGroups[attributeSetId] = value;
    const groups: any = [];
    Object.keys(this.selectedGroups).forEach((setId) => {
      if (this.selectedGroups[setId] != null) {
        groups.push(this.selectedGroups[setId]);
      }
    });
    this.formGroup.get('Groups')?.setValue(groups);
    this.selectionChanged();
  }

  selectionChanged() {
    this.formGroup.markAsDirty();
    this.formGroup.markAsTouched();
  }
  afterSubmit(record: any) {
    if (this.childAttributesToAdd.length === 0) {
      return;
    }
    const attributes: AttributeDTO[] = this.childAttributesToAdd
      .map((child) => {
        return {
          id: child.Id ?? 0,
          name: child.Name,
          label: child.Label,
          type: child.Type,
          scope: this.formGroup.get('Scope')?.value ?? '2',
        } as AttributeDTO;
      })
      .filter((x) => x.name != null && x.name.trim() != '');
    this.subscriptions.push(
      this.attributesService
        .postChilAttributes(
          record?.Id ?? this.formGroup.get('Id')?.value,
          attributes
        )
        .pipe(
          tap(() => {
            this.message.success('Related Attributes saved successfully.');
          })
        )
        .subscribe()
    );
  }

  getChildAttributes() {
    const attributeId = this.formGroup.controls['Id'].value;
    this.subscriptions.push(
      this.attributesService
        .getChildAttributes(attributeId)
        .pipe(
          tap((response) => {
            this.existedChildAttributes = [...response.value];
          })
        )
        .subscribe()
    );
  }
  submitTranslation() {
    if (this.record?.Id == null) {
      this.message.error(
        'Submitting translation is allowed only in the edit mode!'
      );
      return;
    }
    const label = this.formGroup.get('Label')?.value;
    const translations: Translation = {
      Label: label,
      LanguageId: this.languageId,
      ObjectField: 'Label',
      ObjectId: this.record?.Id,
      ObjectType: 1,
    };
    this.connectionService.create(
      `${AppConfigService.settings.dataApiUrl}Translation`,
      translations,
      (d) => {
        this.message.success('Translation saved successfully!');
       // this.router.navigate([this.componentModel.indexPath]);
      }
    );
  }

  onUomSelectionChange(status: any) {
    this.hasUomAttribute = status;
  }
  defaultLanguage: any;
  handleLanguageChange() {
    const translations = this.record.Translations as Translation[];
    const labelTranslation = translations.find(
      (x) => x.LanguageId === this.languageId && x.ObjectField === 'Label'
    );
    this.formGroup.get('Label')?.enable();
    this.formGroup.get('Label')?.setValue(labelTranslation?.Label);
      //new 
    const scope = this.formGroup.get('Scope')?.value; 
    if (scope === '2') {    
      if (this.originalLabel && this.originalLabel.trim() !== '') {
        this.formGroup.get('Label')?.setValue(this.originalLabel);
      }  
    }
  }
  private setupDefaultLanguageSubscription() {
    this.subscriptions.push(
        this.commonService.defaultLanguage.subscribe((defaultLanguage) => {
            this.defaultLanguage = defaultLanguage;
        })
    );
}

  onUnitsChange(uoms: any) {
    this.uoms = uoms;
    this.formGroup.markAsDirty();
    this.formGroup.markAsTouched();
  }

  get RelatedObjectType() {
    return this.formGroup.controls['RelatedObjectType'] as FormControl;
  }
  get Type() {
    return this.formGroup.controls['Type'] as FormControl;
  }
  get Name() {
    return this.formGroup.controls['Name'] as FormControl;
  }
  static controls(mode: string) {
    const controlsToReturn: any = {};
    if (mode === 'edit') {
      controlsToReturn['Id'] = [null, []];
    }

    controlsToReturn['Name'] = [null, [Validators.required]];
    controlsToReturn['Groups'] = [null, []];
    controlsToReturn['Type'] = [null, [Validators.required]];
    controlsToReturn['RelatedObjectType'] = [12, [Validators.required]];
    controlsToReturn['Scope'] = ['2', [Validators.required]];
    controlsToReturn['Visible'] = [true, [Validators.required]];
    controlsToReturn['IsUnique'] = [false, [Validators.required]];
    controlsToReturn['Label'] = [null, [Validators.required]];
    controlsToReturn['AddToCol'] = [true, [Validators.required]];
    controlsToReturn['AttributeOptions'] = [null, []];
    controlsToReturn['RelationObjectType'] = [null, []];
    controlsToReturn['DefaultValue'] = [null, []];
    controlsToReturn['IsRequired'] = [false, [Validators.required]];
    controlsToReturn['UseAigeneration'] = [false, []];
    controlsToReturn['AigenerationQuestion'] = [null, []];
    controlsToReturn['ParentAttributeId'] = [null, []];
    controlsToReturn['AttributeValueObjectNavigations'] = new FormGroup({});
    controlsToReturn['AttributeValidators'] = new FormArray([]);

    //new 
    controlsToReturn['UseInLayeredNavigation'] = [UseInLayeredNavigationValidValues[0].Code]
    controlsToReturn['VisibleInCatalogPages'] = [false]
    controlsToReturn['UseInSearch'] = [false]
    controlsToReturn['UsedInProductListing'] = [false]
     // ///SortInListing
    controlsToReturn['UsedForSortingInProductListing'] = [false]
    //PositionInConfigurableAttribute
    controlsToReturn['Position'] = [0]
   // controlsToReturn['PositionInConfigurableAttribute'] = [0,[Validators.required]]
    
    
    return controlsToReturn;
  }
  initializePagination(): void {
    this.totalItems = this.attributeSets.length; 
    this.paginatedData = this.getPaginatedData(); 
}

  
 // Pagination logic
 getPaginatedData(): AttributeSet[] {
  const startIndex = (this.currentPage - 1) * this.pageSize;
  const endIndex = startIndex + this.pageSize;
  const paginatedData = this.filteredData.slice(startIndex, endIndex);
  return paginatedData;
}
onPageChange(page: number): void {
  this.currentPage = page;
  this.paginatedData = this.getPaginatedData();
}

 

  filterAttributeSets(searchQuery: string) {
    if (!searchQuery) {

      this.filteredData = [...this.attributeSets];
    } else {

      

      this.filteredData = this.attributeSets.filter(set =>
        set.Name.toLowerCase().includes(searchQuery.toLowerCase()),
      );
      // this.filteredData.forEach(set => {
      //   console.log('Matched Name:', set.Name);
      // });
    }
  
    
    this.totalItems = this.filteredData.length;
    this.currentPage = 1;
    this.paginatedData = this.getPaginatedData();
  }
  searchChange(){
    this.searchQueryControl.valueChanges.subscribe(value => {

      this.filterAttributeSets(value); 
    });
  }

}
